export default __webpack_public_path__ + "static/media/img05.0990ec57.svg";